module.exports = __webpack_public_path__ + "static/media/print.4e7964e2.svg";